module.exports = __webpack_public_path__ + "img/rank-tips.ba212116.png";